const ADMIN_ROLE_VALUES = Object.freeze([0, 999]);
// IES4の単票取込は 0(管理者) / 1(一般) / 999(システム管理者) に公開済み。
// 2(経理) / 3(閲覧権限なし) は報告書を作らないため対象外。
// API側(Api::V1::TMeasurementReportsController)でも同じ条件を検証している。
const IES4_IMPORT_ALLOWED_ROLES = Object.freeze([0, 1, 999]);

const normalizeRoleValue = (roleValue) => {
  const parsedRole = Number(roleValue);
  return Number.isNaN(parsedRole) ? null : parsedRole;
};

export const isAdminRole = (roleValue) => {
  const normalizedRole = normalizeRoleValue(roleValue);
  return normalizedRole !== null && ADMIN_ROLE_VALUES.includes(normalizedRole);
};

export const currentRoleFromStoreOrLocalStorage = (storeRole) => (
  storeRole ?? localStorage.getItem('userRole')
);

export const canUseIes4Import = (roleValue) => {
  const normalizedRole = normalizeRoleValue(roleValue);
  return normalizedRole !== null && IES4_IMPORT_ALLOWED_ROLES.includes(normalizedRole);
};

// IES4一括取込はシステム管理者のみ。単票取込より狭い権限として別に持つ。
export const canUseIes4BulkImport = (roleValue) => normalizeRoleValue(roleValue) === 999;
